var _g, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_957_1",
    "data-name": "Componente 957 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43.171,
    viewBox: "0 0 43 43.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1349",
    "data-name": "Grupo 1349",
    transform: "translate(-7 1.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_52",
    "data-name": "Uni\\xE3o 52",
    d: "M29.575,33.986l-4.6-2.393c-.452-.236-.986-.479-1.432-.727a18.507,18.507,0,0,1-6.289,1.089C7.727,31.955,0,24.806,0,15.979S7.727,0,17.26,0,34.532,7.155,34.532,15.979a15.183,15.183,0,0,1-3.755,9.949c.132.392.246.823.362,1.211l1.4,4.714a1.924,1.924,0,0,1-1.958,2.384A2.155,2.155,0,0,1,29.575,33.986Z",
    transform: "translate(7 7.28)",
    fill: "#8cdbde"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1389",
    "data-name": "Grupo 1389",
    transform: "translate(12 21.279)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_77",
    "data-name": "Elipse 77",
    cx: 2.402,
    cy: 2.402,
    r: 2.402,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_78",
    "data-name": "Elipse 78",
    cx: 2.402,
    cy: 2.402,
    r: 2.402,
    transform: "translate(9.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_79",
    "data-name": "Elipse 79",
    cx: 2.402,
    cy: 2.402,
    r: 2.402,
    transform: "translate(18.861)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1535",
    "data-name": "Grupo 1535",
    transform: "translate(-1767.707 -27.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2661",
    "data-name": "Grupo 2661",
    transform: "translate(1794.207 30.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_83",
    "data-name": "Elipse 83",
    transform: "translate(-3.5 -3.434)",
    fill: "#fff",
    stroke: "#c4eded",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(29 1.934)",
    fill: "#475757",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 13
  }, "7"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenchat);
export default __webpack_public_path__ + "static/media/Greenchat.042cae4f409de4cd430c70da5acba10d.svg";
export { ForwardRef as ReactComponent };